import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import translationEN from './locales/english.json'
import translationDA from './locales/danish'

const resources = {
    gb: {
        translation: translationEN,
    },
    dk: {
        translation: translationDA,
    },
}

i18n.use(initReactI18next).init({
    resources,
    lng: 'gb',
    interpolation: {
        escapeValue: false,
    },
})

export default i18n
